import React, { FC } from "react";
import { Select } from "@xapp/components";
export interface PageSizeSelectorProps {
    readonly value: number;
    onChange(value: number): void;
    itemsPerPage?: number[];
}

export const PageSizeSelector: FC<PageSizeSelectorProps> = ({
    itemsPerPage,
    value,
    onChange
}: PageSizeSelectorProps) => {

    const itemsArray = itemsPerPage || [50, 100, 250, 500]

    const sources = itemsArray.map(value => ({
        label: value.toString(),
        value
    }));

    return (
        <div style={{ marginBottom: 15 }}>
            <Select items={sources} value={value} onChange={(val) => onChange(Number(val))} />
        </div>
    );
};

